import { useCardCategoryContext } from '../CardCategoryProvider';
import { useIsPublicGallerySsr } from './useIsPublicGallerySsr';

/**
 * The seed every placement decision in a server-rendered gallery derives from (PRNT-5494): promo
 * columns, the repeat shuffle, concierge spacing and the concierge offerings' order. One value for
 * every caller, so the server and the client — and every hook on the client — agree. `undefined`
 * off that path, where placement stays per-session random.
 */
export const useGalleryPlacementSeed = (): string | undefined => {
  const { currentCategory } = useCardCategoryContext();
  const isPublicGallerySsr = useIsPublicGallerySsr();
  return isPublicGallerySsr ? currentCategory : undefined;
};
